import { create } from "zustand";

interface BookingPopupState {
  /** bookingPopupKey()s the owner closed manually; the popup stays hidden for these until reopened or that response window expires. */
  dismissedIds: string[];
  dismiss: (id: string) => void;
  /** Shows a booking's popup again - every response window of that booking, whatever its attempt number. */
  reopen: (bookingId: string) => void;
}

export const useBookingPopupStore = create<BookingPopupState>((set) => ({
  dismissedIds: [],
  dismiss: (id) => set((state) => (state.dismissedIds.includes(id) ? state : { dismissedIds: [...state.dismissedIds, id] })),
  // dismissedIds hold bookingPopupKey()s ("<bookingId>:<attempt>"), so match on the booking id prefix.
  reopen: (bookingId) => set((state) => ({ dismissedIds: state.dismissedIds.filter((item) => !item.startsWith(`${bookingId}:`)) })),
}));
